export class ApiException extends Error {
  public code?: string;
  public retryable?: boolean;
  public requiresNewCode?: boolean;
  public details?: unknown;
  public status?: string | number;

  constructor (params: {
    message: string
    code?: string
    retryable?: boolean
    requiresNewCode?: boolean
    details?: unknown,
    status?: string | number
  }) {
    super(params.message);
    this.name = 'ApiException';

    this.code = params.code;
    this.retryable = params.retryable;
    this.requiresNewCode = params.requiresNewCode;
    this.details = params.details;
    this.status = params.status;
  }
}
